import { formatCustomDate } from "helpers/dateTools";
import { fillingOrderTypes } from "./types";

const { 
  DELETE_FILLING_ORDERS, 
  GET_FILLING_ORDERS, 
  FILLING_ORDER_INPUTS, 
  FILLING_ORDER_DESELECT_PENDING,
  FILLING_ORDER_SELECT_PENDING, 
  FILLING_ORDER_SELECT, 
  FILLING_ORDER_DESELECT
} = fillingOrderTypes

const initialState = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: {},
  fillingOrders: [],
  fillingOrdersToDelete: []
} 

export const fillingOrderReducer = (state=initialState, { type, payload }) => {
  switch (type) {
    case FILLING_ORDER_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      }
    case GET_FILLING_ORDERS:
      return {
        ...state,
        fillingOrders: payload,
      }
    case DELETE_FILLING_ORDERS: 
      const { errorIds, goodIds } = payload
      const filteredOrders = state.fillingOrders.filter(order => !goodIds.includes(order?.id))
      let newOrders = filteredOrders
      if(errorIds.length) {
        newOrders = filteredOrders.map(order => {
          if (errorIds.includes(order?.id)) return {
            ...order,
            status: 'ERROR'
          }
          else return order
        })
      }
      return {
        ...state,
        fillingOrders: newOrders
      }
    case FILLING_ORDER_SELECT_PENDING: 
      const newFillingOrdersToDelete = []
      const fillingOrdersToMap = state?.fillingOrders || []
      fillingOrdersToMap.map(order => {
        if(order.status === 'PENDIENTE') newFillingOrdersToDelete.push(order.id)
      })
      return {
        ...state,
        fillingOrdersToDelete: newFillingOrdersToDelete
      }
    case FILLING_ORDER_DESELECT_PENDING: 
      return {
        ...state,
        fillingOrdersToDelete: []
      }
    case FILLING_ORDER_SELECT: 
      return {
        ...state,
        fillingOrdersToDelete: [...state.fillingOrdersToDelete, payload]
      }
    case FILLING_ORDER_DESELECT: 
      return {
        ...state,
        fillingOrdersToDelete: state.fillingOrdersToDelete.filter(id => id !== payload)
      }
    default:
      return state;
  }
}